/**
 * @fileoverview gRPC-Web generated client stub for passport
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.2
// 	protoc              v3.21.12
// source: protobuf/passport/passport.proto


/* eslint-disable */
// @ts-nocheck


import * as grpcWeb from 'grpc-web';

import * as protobuf_model_merged_pb from '../../protobuf/model/merged_pb';
import * as protobuf_passport_passport_pb from '../../protobuf/passport/passport_pb';


export class PassportServiceClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: any; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: any; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'binary';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname.replace(/\/+$/, '');
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodDescriptorList = new grpcWeb.MethodDescriptor(
    '/passport.PassportService/List',
    grpcWeb.MethodType.UNARY,
    protobuf_passport_passport_pb.ListPassportsRequest,
    protobuf_passport_passport_pb.ListPassportsResponse,
    (request: protobuf_passport_passport_pb.ListPassportsRequest) => {
      return request.serializeBinary();
    },
    protobuf_passport_passport_pb.ListPassportsResponse.deserializeBinary
  );

  list(
    request: protobuf_passport_passport_pb.ListPassportsRequest,
    metadata: grpcWeb.Metadata | null): Promise<protobuf_passport_passport_pb.ListPassportsResponse>;

  list(
    request: protobuf_passport_passport_pb.ListPassportsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: protobuf_passport_passport_pb.ListPassportsResponse) => void): grpcWeb.ClientReadableStream<protobuf_passport_passport_pb.ListPassportsResponse>;

  list(
    request: protobuf_passport_passport_pb.ListPassportsRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: protobuf_passport_passport_pb.ListPassportsResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/passport.PassportService/List',
        request,
        metadata || {},
        this.methodDescriptorList,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/passport.PassportService/List',
    request,
    metadata || {},
    this.methodDescriptorList);
  }

  methodDescriptorGet = new grpcWeb.MethodDescriptor(
    '/passport.PassportService/Get',
    grpcWeb.MethodType.UNARY,
    protobuf_passport_passport_pb.GetPassportsRequest,
    protobuf_passport_passport_pb.GetPassportsResponse,
    (request: protobuf_passport_passport_pb.GetPassportsRequest) => {
      return request.serializeBinary();
    },
    protobuf_passport_passport_pb.GetPassportsResponse.deserializeBinary
  );

  get(
    request: protobuf_passport_passport_pb.GetPassportsRequest,
    metadata: grpcWeb.Metadata | null): Promise<protobuf_passport_passport_pb.GetPassportsResponse>;

  get(
    request: protobuf_passport_passport_pb.GetPassportsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: protobuf_passport_passport_pb.GetPassportsResponse) => void): grpcWeb.ClientReadableStream<protobuf_passport_passport_pb.GetPassportsResponse>;

  get(
    request: protobuf_passport_passport_pb.GetPassportsRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: protobuf_passport_passport_pb.GetPassportsResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/passport.PassportService/Get',
        request,
        metadata || {},
        this.methodDescriptorGet,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/passport.PassportService/Get',
    request,
    metadata || {},
    this.methodDescriptorGet);
  }

  methodDescriptorUpsert = new grpcWeb.MethodDescriptor(
    '/passport.PassportService/Upsert',
    grpcWeb.MethodType.UNARY,
    protobuf_passport_passport_pb.UpsertPassportRequest,
    protobuf_model_merged_pb.PassportResponse,
    (request: protobuf_passport_passport_pb.UpsertPassportRequest) => {
      return request.serializeBinary();
    },
    protobuf_model_merged_pb.PassportResponse.deserializeBinary
  );

  upsert(
    request: protobuf_passport_passport_pb.UpsertPassportRequest,
    metadata: grpcWeb.Metadata | null): Promise<protobuf_model_merged_pb.PassportResponse>;

  upsert(
    request: protobuf_passport_passport_pb.UpsertPassportRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: protobuf_model_merged_pb.PassportResponse) => void): grpcWeb.ClientReadableStream<protobuf_model_merged_pb.PassportResponse>;

  upsert(
    request: protobuf_passport_passport_pb.UpsertPassportRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: protobuf_model_merged_pb.PassportResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/passport.PassportService/Upsert',
        request,
        metadata || {},
        this.methodDescriptorUpsert,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/passport.PassportService/Upsert',
    request,
    metadata || {},
    this.methodDescriptorUpsert);
  }

  methodDescriptorDelete = new grpcWeb.MethodDescriptor(
    '/passport.PassportService/Delete',
    grpcWeb.MethodType.UNARY,
    protobuf_passport_passport_pb.DeletePassportsRequest,
    protobuf_passport_passport_pb.DeletePassportsResponse,
    (request: protobuf_passport_passport_pb.DeletePassportsRequest) => {
      return request.serializeBinary();
    },
    protobuf_passport_passport_pb.DeletePassportsResponse.deserializeBinary
  );

  delete(
    request: protobuf_passport_passport_pb.DeletePassportsRequest,
    metadata: grpcWeb.Metadata | null): Promise<protobuf_passport_passport_pb.DeletePassportsResponse>;

  delete(
    request: protobuf_passport_passport_pb.DeletePassportsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: protobuf_passport_passport_pb.DeletePassportsResponse) => void): grpcWeb.ClientReadableStream<protobuf_passport_passport_pb.DeletePassportsResponse>;

  delete(
    request: protobuf_passport_passport_pb.DeletePassportsRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: protobuf_passport_passport_pb.DeletePassportsResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/passport.PassportService/Delete',
        request,
        metadata || {},
        this.methodDescriptorDelete,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/passport.PassportService/Delete',
    request,
    metadata || {},
    this.methodDescriptorDelete);
  }

}

